import { faTruck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { getVesselColourClasses } from "../../helpers/common";
import dayjs from "../../helpers/dayjsSetup";
import { useGlobalFilters } from "../../providers/GlobalFiltersProvider";
import ContainerService from "../../services/Container/ContainerService";

export default function GridDashboard({ filterStatus, filterSupplier }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { filters } = useGlobalFilters();

  const { data: containersData = {}, isLoading } = useQuery({
    queryKey: ["containersData", filterSupplier, filterStatus, filters],
    queryFn: () => ContainerService.loadMobileViewContainersData({ filterSupplier, filterStatus, ...filters })
  });

  const onContainerClick = (containerId) => {
    navigate("/shipment-gateway/shipment-details", {
      state: {
        pathname: location.pathname,
        containerID: containerId,
        activeView: 'grid',
        filterSupplier,
        filterStatus,
      },
    });
  };

  const isEmpty = !containersData || Object.keys(containersData).length === 0;

  return (
    <Spin spinning={isLoading} size="large">
      <div
        className="flex flex-col bg-white rounded-3xl p-3 sm:p-5"
        style={{ flex: 1 }}
      >
        {isEmpty && !isLoading ? (
          <div className="text-gray-400 text-center text-sm sm:text-base">
            No records found
          </div>
        ) : (
          Object.entries(containersData)
            .sort(([dateA], [dateB]) => new Date(dateA) - new Date(dateB)) // Sort ascending
            .map(([date, containers]) => {
              const formattedDate = dayjs(date).format("DD MMM (ddd)")

              return (
                <div key={date} className="mb-2">
                  <div className="flex flex-col md:flex-row items-start">
                    <h2 className="font-bold text-sm sm:text-base md:text-sm min-w-[150px]">
                      {formattedDate}
                    </h2>

                    <div className="flex flex-wrap gap-3 w-full">
                      {containers.length !== 0 ? (
                        containers.map((container, index) => {
                          const vesselClasses = getVesselColourClasses(
                            container.vesselName
                          );
                          return (
                            <div
                              key={index}
                              className={`${vesselClasses.bg} p-1 rounded-lg cursor-pointer 
                          w-[100%] sm:w-[100%] md:w-[320px]`}
                              onClick={() => onContainerClick(container.id)}
                            >
                              <div className="bg-white ml-2 px-2 py-1 hover:bg-gray-100">
                                <div
                                  className="
    grid grid-cols-[2fr,1fr,1fr,0.5fr] md:grid-cols-[2fr,1fr,1fr,0.5fr]
    md:gap-x-4 gap-2 items-center w-full
  "
                                >
                                  <span className="font-semibold text-sm md:text-md">
                                    {container.containerNum}
                                  </span>

                                  <span className="text-xs">
                                    {container.containerLoadType === "LCL"
                                      ? container.containerLoadType
                                      : container.type}
                                  </span>

                                  <span className="text-xs">
                                    {container.statusName}
                                  </span>

                                  <span className="flex justify-center">
                                    {container.deliveryDate != null && (
                                      <FontAwesomeIcon
                                        icon={faTruck}
                                        className={`text-xs ${container.isDeliveryConfirmed
                                          ? "text-green-500"
                                          : "text-red-500"
                                          }`}
                                      />
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <span className="text-gray-400 text-xs md:text-sm">
                          No containers
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
        )}
      </div>
    </Spin>
  );
}